define('lq/events/actions/pdfDataCommand',['lq/events/actions/eventAction'], function (EventAction) {
    'use strict';

    var PdfDataCommand = function(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
        return this;
    };

    EventAction.extend(PdfDataCommand, EventAction);

    PdfDataCommand.typeName = 'PdfDataCommand';

    PdfDataCommand.prototype.getBatchType = function () {
        return EventAction.COMMAND_BATCH;
    };

    PdfDataCommand.prototype.createEventActionRequest = function () {
        return {
            eventActionType: 'PdfData',
            command: this.eventData.command
        };
    };    

    return PdfDataCommand;
});
